import { Text, Table, Button, VStack } from "@chakra-ui/react"
import { formatCurrency } from "@/utilities/number"
import { useAuth } from "contexts/auth"
import { useStore } from "contexts/store"
import GuestPriceNotice from "./GuestPriceNotice"

const TierProductPrice = ({ priceList = [], onPriceItemClick }) => {
    const { user, showLogin } = useAuth()
    const { store } = useStore()
    const canShowPrice = !!user || !!store?.web?.public_price_display
    const btnLoginClick = async () => {
        var data = await showLogin();
        if (data) {
            window.location.reload();
        }


    }

    if (!canShowPrice) {

        return (
            <VStack>
                <GuestPriceNotice />
                <Button onClick={btnLoginClick}>
                    Đăng nhập
                </Button>
            </VStack>
        )



    }

    return (
        <>
            <Text fontWeight="semibold">Giá</Text>
            <Table.Root size="sm">
                <Table.Header>
                    <Table.Row>
                        <Table.ColumnHeader>Số Lượng</Table.ColumnHeader>
                        <Table.ColumnHeader textAlign="end">Giá</Table.ColumnHeader>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {priceList.map((item) => (
                        <Table.Row key={item.id}>
                            <Table.Cell>Từ {item.min}</Table.Cell>
                            <Table.Cell textAlign="end">
                                {onPriceItemClick ? (
                                    <Button variant="ghost" onClick={() => onPriceItemClick(item.min)}>
                                        {formatCurrency(item.price)}
                                    </Button>
                                ) : (
                                    formatCurrency(item.price)
                                )}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>
        </>
    )
}

export default TierProductPrice